/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { Dropdown, useInputHelper } from 'framework/form';
import { useVacancyGroupService, POSITION_STATUS } from 'domain/shared/newVacancy';
import { formatDate } from 'domain/shared/newVacancy';

type VacancyByGroupDropdownProps = {
  label?: string;
  source: string;
  vacancyGroupId: string | null;
  placeholder?: string;
  disabled?: boolean;
  value?: Nullable<string>;
  className?: string;
  helpText?: string;
};

const buildLabel = ({ specialization, title, positions }: any) => {
  const openPositions = positions?.filter(({ status }: any) => status === POSITION_STATUS.OPEN) || [];

  // Get the earliest forecast date from all open positions
  let earliestForecastDate;
  if (openPositions.length > 0) {
    earliestForecastDate = openPositions.reduce((earliest: string, position: any) => {
      if (!earliest || (position.forecastDate && position.forecastDate < earliest)) {
        return position.forecastDate;
      }
      return earliest;
    }, null);
  }

  const forecastDate = earliestForecastDate ? formatDate(earliestForecastDate) : '';
  return !title ? `${specialization} (${forecastDate})` : `${title} (${forecastDate})`;
};

const VacancyByGroupDropdown = ({ label, vacancyGroupId, ...props }: VacancyByGroupDropdownProps) => {
  const [vacancies, setVacancies] = useState<any[]>([]);
  const { getLabel } = useInputHelper({ label, ...props });
  const { searchVacanciesByGroup } = useVacancyGroupService();

  useEffect(() => {
    (async () => {
      if (vacancyGroupId) {
        try {
          const { result } = await searchVacanciesByGroup(vacancyGroupId);
          setVacancies(result);
        } catch (e) {
          setVacancies([]);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dropdown
      label={getLabel()}
      options={vacancies.map(vacancy => ({
        value: vacancy.id,
        label: buildLabel(vacancy),
      }))}
      {...props}
    />
  );
};

export default VacancyByGroupDropdown;
